import { orchestrator } from 'satcheljs';
import { logInlineFeedbackDialogResponse } from '../actions/logInlineFeedbackDialogResponse';
import { sendInlineFeedbackDialogDatapoint } from '../services/sendInlineFeedbackDialogDatapoint';

export default orchestrator(logInlineFeedbackDialogResponse, async dialogResponse => {
    await sendInlineFeedbackDialogDatapoint({
        sessionId: dialogResponse.sessionId,
        inlineFeedbackResponseText: dialogResponse.inlineFeedbackResponseText,
        inlineFeedbackResponseCategories: dialogResponse.inlineFeedbackResponseCategories,
        isContentDonated: dialogResponse.isContentDonated,
        isUVTicketCreated: dialogResponse.isUVTicketCreated,
    });
});
